function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.4 14H1.1C0.808356 13.9996 0.528744 13.8654 0.32252 13.6268C0.116297 13.3882 0.000305745 13.0647 0 12.7273V1.27273C0.000305745 0.935288 0.116297 0.61177 0.32252 0.373164C0.528744 0.134558 0.808356 0.000353755 1.1 0H4.4C4.69164 0.000353755 4.97126 0.134558 5.17748 0.373164C5.3837 0.61177 5.49969 0.935288 5.5 1.27273V12.7273C5.49969 13.0647 5.3837 13.3882 5.17748 13.6268C4.97126 13.8654 4.69164 13.9996 4.4 14ZM1.1 1.27273V12.7273H4.4V1.27273H1.1Z",
  fill: "#080B11"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.65 14H7.35C7.05836 13.9996 6.77874 13.8654 6.57252 13.6268C6.3663 13.3882 6.25031 13.0647 6.25 12.7273V1.27273C6.25031 0.935288 6.3663 0.61177 6.57252 0.373164C6.77874 0.134558 7.05836 0.000353755 7.35 0H10.65C10.9416 0.000353755 11.2213 0.134558 11.4275 0.373164C11.6337 0.61177 11.7497 0.935288 11.75 1.27273V12.7273C11.7497 13.0647 11.6337 13.3882 11.4275 13.6268C11.2213 13.8654 10.9416 13.9996 10.65 14ZM7.35 1.27273V12.7273H10.65V1.27273H7.35Z",
  fill: "#080B11"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.9 14H13.6C13.3084 13.9996 13.0287 13.8654 12.8225 13.6268C12.6163 13.3882 12.5003 13.0647 12.5 12.7273V1.27273C12.5003 0.935288 12.6163 0.61177 12.8225 0.373164C13.0287 0.134558 13.3084 0.000353755 13.6 0H16.9C17.1916 0.000353755 17.4713 0.134558 17.6775 0.373164C17.8837 0.61177 17.9997 0.935288 18 1.27273V12.7273C17.9997 13.0647 17.8837 13.3882 17.6775 13.6268C17.4713 13.8654 17.1916 13.9996 16.9 14ZM13.6 1.27273V12.7273H16.9V1.27273H13.6Z",
  fill: "#080B11"
});

const SvgGridView = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgGridView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grid_view.67039344.svg";
export { ForwardRef as ReactComponent };